import { Service } from '@angular/core';

@Service()
export class VanillaRoutingService {
  isVanillaRoutingInProgress = false;
}
